import { NavLink } from 'react-router-dom'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'

import { ReactComponent as Logout } from '@src/assets/navigation/logout.svg'
import { ReactComponent as DeleteUser } from '@src/assets/navigation/delete-user-new.svg'
import { ReactComponent as Logo } from '@src/assets/logo.svg'
import { ReactComponent as Cross } from '@src/assets/cross.svg'
import { navigationLinks } from '@src/constants/navigation'
import { AppDispatch } from '@src/store/store'
import { setIsOpenNav } from '@src/store/ducks/app/reducer'
import { logout } from '@src/store/ducks/auth/thunks'
import style2 from '@src/pages/RecoveryPassword/RecoveryPassword.module.scss'
import { Button } from '@src/components/Button/Button'
import { Modal } from '@src/components/Modal/Modal'
import { selectIsLoading } from '@src/store/ducks/auth/selectors'
import { deleteUser } from '@src/store/ducks/user/thunks'
import { selectIsStatusDeleteUser, selectProfile } from '@src/store/ducks/user/selectors'
import style from './Navigation.module.scss'

export const Navigation = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isLoading = useSelector(selectIsLoading)
  const isDeleteUserStatus = useSelector(selectIsStatusDeleteUser)
  const profile = useSelector(selectProfile)
  let cleanedNumber = profile?.phone.replace(/\D/g, '')
  if (cleanedNumber.length < 12) {
    cleanedNumber = `375${cleanedNumber}`
  }

  return (
    <div className={style.nav}>
      <div className={style.header}>
        <a href="/">
          <Logo />
        </a>

        <button type="button" className={style.close} onClick={() => { dispatch(setIsOpenNav(false)) }}>
          <Cross />
        </button>

      </div>
      {navigationLinks.map((link) => (
        <NavLink
          key={link.url}
          className={({ isActive }) => cn(style.item, isActive && style.item__active)}
          to={`/lk/${link.url}`}
          onClick={() => { dispatch(setIsOpenNav(false)) }}
        >
          <link.icon className={style.item_icon} />
          {link.name}
        </NavLink>
      ))}

      <button onClick={() => { dispatch(logout()) }} type="button" className={cn(style.item, style.item__logout)}>
        <Logout className={style.item_icon} />
        Выйти из личного кабинета
      </button>

      {/* {(cleanedNumber === '375298727286' || cleanedNumber === '375447296171' || cleanedNumber === '375447554820' || cleanedNumber === '375298610035') && ( */}
      <button
        onClick={() => {
          setIsModalOpen(true)
        }}
        type="button"
        className={cn(style.item, style.item__delete)}
      >
        <DeleteUser className={style.item_icon} />
        {isDeleteUserStatus ? 'Отменить удаление' : 'Удалить аккаунт'}
      </button>
      {/* )} */}

      <Modal isOpen={isModalOpen} close={() => setIsModalOpen(false)}>
        <>
          { !isDeleteUserStatus ? (
            <>
              <div className={style2.titleModal}>Вы уверены, что хотите удалить аккаунт?</div>
              <div className={style2.descriptionModal}>(Аккаунт будет удален в течении 24 часов)</div>
            </>
          ) : (<div className={style2.titleModal}>Вы уверены, что хотите отменить удаление аккаунта?</div>)}
          <Button
            onClickFunc={() => { dispatch(deleteUser()) }}
            loading={isLoading}
            type="attention"
          >
            {!isDeleteUserStatus ? 'Удалить' : 'Отменить'}
          </Button>
        </>
      </Modal>
    </div>
  )
}
